export const setExpiredSession = () => {
    if (localStorage.getItem("logged") === "true" || !localStorage.getItem("logged")) {
        
        localStorage.setItem("logged", "false");
        alert("Sesión caducada. Vuelva a introducir sus credenciales, por favor.")
        window.location.href = '/'
    }
}